export interface IAddOrRemoveProductFromCategory {
    categoryId: string | null;
    products: string[] | null;
}

export class AddOrRemoveProductFromCategory implements IAddOrRemoveProductFromCategory {
    public categoryId: string | null;
    public products: string[] | null;

    constructor(categoryId: string | null, products: string[] | null){
        this.categoryId = categoryId;
        this.products = products;
    }
}